import * as React from 'react';
import Popover from '@mui/material/Popover';
import { Box, IconButton } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CustomText from 'components/common/CustomText/CustomText';
import EditIcon from 'icons/EditIcon';
import DeleteIcon from 'icons/DeleteIcon';
import { colors } from 'styles/colors';
import useGlobalStyles from 'styles/globalStyles';
import { useNavigate } from 'react-router-dom';
import {  useState } from 'react';
import { useAuth } from 'context/AuthContext';
import { useGetEducationById, useGetExperienceById } from 'hooks/useUsers';
import DeleteEducationDialog from '../DeleteEducationDialog/DeleteEducationDialog';
import EducationDialog from '../EducationDialog/EducationDialog';

interface Props {
  educationId: number;
}

export default function EducationOptions({ educationId }: Props) {
  const { user } = useAuth();
  const globalStyles = useGlobalStyles();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const [openDelete, setOpenDelete] = useState<boolean>(false);
  const [openDialog, setOpenDialog] = useState<boolean>(false);

  const { data } = useGetEducationById({
    userId: user.id,
    educationId,
  });

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onEditClick = () => {
    handleClose();
    setOpenDialog(true);
  }

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const onDeleteClick = () => {
    handleClose();
    setOpenDelete(true);
  }

  return (
    <div>

      <IconButton
        onClick={handleClick}
        className={globalStyles.p0}
        disableRipple
      >
        <MoreVertIcon sx={{ color: colors.secondary }} />
      </IconButton>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            borderRadius: '10px',
            overflow: 'hidden',
            maxWidth: '200px'
          }}
          p={1}
        >
          <IconButton
            onClick={onEditClick}
            className={globalStyles.popoverButtonContainer}
          >
            <Box className={globalStyles.popoverIconContainer}>
              <EditIcon color={colors.black} />
            </Box>
            <CustomText text="Edit" ml="5px" color={colors.black} />
          </IconButton>

          <IconButton className={globalStyles.popoverButtonContainer} onClick={onDeleteClick}>
            <Box className={globalStyles.popoverIconContainer}>
              <DeleteIcon color={colors.black} />
            </Box>
            <CustomText text="Delete" ml="5px" color={colors.black} />
          </IconButton>
        </Box>
      </Popover>

      <DeleteEducationDialog
        open={openDelete}
        setOpen={setOpenDelete}
        userId={user.id}
        educationId={educationId}
      />

      <EducationDialog
        open={openDialog}
        setOpen={(setOpenDialog)}
        educationId={educationId}
      />

    </div>
  );
}
